module.exports = __webpack_public_path__ + "static/media/violon.6e94a0f1.jpg";